import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import {
	Paper,
	Toolbar,
	Typography,
	Dialog,
	MenuItem,
	Grid,
	Button,
	TextField,
	List,
	ListItem,
	ListItemText,
	Divider,
	FormControl,
	InputLabel,
	OutlinedInput,
	Snackbar
} from '@material-ui/core'
import MuiDownshift from 'mui-downshift'
import {
	Save as SaveIcon,
	Add as AddIcon,
	Code as CodeIcon,
	// Delete as DeleteIcon
} from '@material-ui/icons'
import { withStyles } from '@material-ui/core/styles'
import { Link } from 'react-router-dom'
import Segment from '../../components/Segment'
import feathersClient, { services } from '../../redux/FeathersRedux'
import { Link as RouterLink } from 'react-router-dom'
import classNames from 'classnames'
import MaskedInput from 'react-text-mask'
import EquipmentsSTCodeDialog from './EquipmentsSTCodeDialog';
import MySnackbarContent from '../../components/MySnackbar'
// import Downshift from 'downshift'

function TextMaskCustom(props) {
	const { inputRef, ...other } = props

	return (
		<MaskedInput
			{...other}
			ref={ref => {
				inputRef(ref ? ref.inputElement : null)
			}}
			mask={[
				/\w/,
				/\w/,
				':',
				/\w/,
				/\w/,
				':',
				/\w/,
				/\w/,
				':',
				/\w/,
				/\w/,
				':',
				/\w/,
				/\w/,
				':',
				/\w/,
				/\w/
			]}
			// placeholderChar={'\u2000'}
			// showMask
			guide
		/>
	)
}

const styles = theme => ({
	button: {
		margin: theme.spacing.unit
	},
	leftIcon: {
		marginRight: theme.spacing.unit
	},
	rightIcon: {
		marginLeft: theme.spacing.unit
	},
	iconSmall: {
		fontSize: 20
	},
	container: {
		display: 'flex',
		flexWrap: 'wrap'
	}
})

const EQUIPMENT_TYPES = [
	{
		label: 'Smart Things',
		value: 'SMARTTHINGS'
	},
	{
		label: 'Otros',
		value: 'OTHERS'
	}
]

const EQUIPMENT_STATUS = [
	{
		label: 'Activo',
		value: 'ACTIVE'
	},
	{
		label: 'Pruebas',
		value: 'TEST'
	},
	{
		label: 'En almacén',
		value: 'WAREHOUSE'
	},
	{
		label: 'Deshabilitado',
		value: 'DISABLED'
	}
]

const INITIAL_STATE = {
	client: '',
	equipmentType: '',
	serialNumber: '',
	mac: '',
	status: '',
	operator: '5c6afc2dffd8a8168cbf08b6',
	sensors: []
}

class EquipmentsEdit extends Component {
	state = {
		loading: true,
		initialDownshift: 'Ivan Jurado',
		clients: [],
		equipment: {
			...INITIAL_STATE
		},
		modalOpen: false,
		modalScriptOpen: false,
		currentSensor: {
			name: '',
			type: '',
			area: ''
		},
		snackbar: {
			open: false,
			message: '',
			variant: 'success'
		},
		initialClient: null,
		devices: []
	}

	componentDidMount() {
		this.getEquipmentData()
	}

	getEquipmentData = () => {
		this.props
			.equipmentGet(this.props.match.params.id, {
				query: {
					$populate: [
						{
							path: 'client',
							select: ['name', 'lastName']
						}
					]
				}
			})
			.then(res => {
				const clients = {
					label: `${res.value.client.name} ${res.value.client.lastName}`,
					value: res.value.client._id
				}
				// const client = `${res.value.client.name} ${res.value.client.lastName}`
				// this.getClients(res.value.client.name)
				// res.value.client = clients[0].value
				this.setState({
					equipment: res.value,
					loading: false,
					initialClient: clients
				})
				this.getDevices(res.value._id)
			})
			.catch(err => {
				console.log(err)
			})
	}

	/**
	 * Enables Snackbar component which displays API response
	 */
	openSnackbar = (message, variant) => {
		this.setState({
			snackbar: {
				open: true,
				message,
				variant
			}
		})
	}

	getClients = async filter => {
		try {
			const clients = await feathersClient.service('clients').find({
				query: {
					$or: [
						{ name: { $search: filter } },
						{ lastName: { $search: filter } },
						{ clientNumber: { $search: filter } }
					]
				}
			})

			this.setState({
				clients: clients.data.map(c => {
					return {
						label: `${c.name} ${c.lastName}`,
						value: c._id
					}
				})
			})
		} catch (e) {}
	}

	getDevices = async equipmentId => {
		console.log(equipmentId)
		try {
			const devices = await feathersClient.service('devices').find({
				query: {
					equipmentId: equipmentId,
					$limit: 999
				}
			})

			this.setState({ devices: devices.data })
			// return devices;
		} catch (e) {}
	}

	updateEquipmentState = (name, value) => {
		this.setState({
			equipment: {
				...this.state.equipment,
				[name]: value
			}
		})
	}

	updateCurrentSensorState = (name, value) => {
		this.setState({
			currentSensor: {
				...this.state.currentSensor,
				[name]: value
			}
		})
	}

	onClientChange = client => {
		let value = client.value ? client.value : ''
		this.updateEquipmentState('client', value)
	}

	handleClose = () => {
		this.setState({
			modalOpen: false
		})
	}

	handleModalScriptClose = () => {
		this.setState({
			modalScriptOpen: false
		})
	}

	addSensor = () => {
		const sensors = this.state.equipment.sensors.concat(
			this.state.currentSensor
		)

		this.setState({
			equipment: {
				...this.state.equipment,
				sensors
			},
			modalOpen: false,
			currentSensor: {
				name: '',
				type: '',
				area: ''
			}
		})
	}

	removeSensor = index => {
		const sensors = [...this.state.equipment.sensors]
		sensors.splice(index, 1)

		this.setState({
			equipment: {
				...this.state.equipment,
				sensors
			}
		})
	}

	checkDisabled = () => {
		const { equipment } = this.state
		return (
			!equipment.client ||
			!equipment.equipmentType ||
			!equipment.mac ||
			!equipment.serialNumber ||
			!equipment.status
		)
	}

	openModalScript = () => {
		this.setState({ modalScriptOpen: true })
	}

	save = () => {
		this.setState({ loading: true })
		// const isThereSensors = this.state.equipment.sensors.length !== 0
		this.props
			.equipmentsPatch(this.props.match.params.id, this.state.equipment)
			.then(res => {
				console.log(res)
				this.openSnackbar('Guardo correctamente', 'success')
				this.setState({ equipment: INITIAL_STATE, loading: false })
				// if (isThereSensors) this.openModalScript()
			})
			.catch(err => {
				console.log(err)
				this.openSnackbar('Hubo un error al guardar', 'error')
				this.setState({ loading: false })
			})
	}

	render() {
		const { classes } = this.props
		const { devices, initialClient, equipment } = this.state
		return (
			<div>
				<Toolbar disableGutters>
					<Typography variant="h6" style={{ flex: 1 }}>
						<Link component={RouterLink} to="/equipments">
							{'Equipos'}
						</Link>
						{' > Creación'}
					</Typography>

					<Button
						onClick={this.openModalScript}
						size="small"
						color="secondary"
						variant="contained"
						style={{ marginRight: 12 }}
					>
						<CodeIcon
							className={classNames(classes.leftIcon, classes.iconSmall)}
						/>
						{'Código ST'}
					</Button>

					<Button
						onClick={this.save}
						size="small"
						color="primary"
						variant="contained"
						disabled={this.checkDisabled()}
					>
						<SaveIcon
							className={classNames(classes.leftIcon, classes.iconSmall)}
						/>
						{'Guardar'}
					</Button>
				</Toolbar>
				<Segment loading={this.state.loading}>
					<Grid container spacing={16}>
						<Grid item lg={8} md={8} sm={12}>
							<Toolbar disableGutters>
								<Typography variant="subtitle1">
									{'Información general'}
								</Typography>
							</Toolbar>
							<Paper style={{ padding: 16 }}>
								<Grid container spacing={16}>
									<Grid item lg={12} md={12} sm={12}>
										{initialClient ? (
											<MuiDownshift
												defaultSelectedItem={initialClient}
												items={this.state.clients}
												variant="outlined"
												getInputProps={() => {
													return {
														fullWidth: true,
														label: 'Cliente'
													}
												}}
												onInputValueChange={this.getClients}
												onChange={this.onClientChange}
											/>
										) : (
											<TextField
												label="Cliente"
												variant="outlined"
												fullWidth
												margin="none"
											/>
										)}
									</Grid>

									<Grid item lg={12} md={12} sm={12}>
										<TextField
											select
											label="Tipo de equipo"
											variant="outlined"
											fullWidth
											margin="none"
											value={equipment.equipmentType}
											onChange={event => {
												this.updateEquipmentState(
													'equipmentType',
													event.target.value
												)
											}}
										>
											{EQUIPMENT_TYPES.map(option => (
												<MenuItem key={option.value} value={option.value}>
													{option.label}
												</MenuItem>
											))}
										</TextField>
									</Grid>

									<Grid item lg={6} md={6} sm={12}>
										<TextField
											label="#Serial"
											variant="outlined"
											fullWidth
											margin="none"
											value={equipment.serialNumber}
											onChange={event => {
												this.updateEquipmentState(
													'serialNumber',
													event.target.value
												)
											}}
										/>
									</Grid>

									<Grid item lg={6} md={6} sm={12}>
										<FormControl
											className={classes.formControl}
											fullWidth
											variant="outlined"
										>
											<InputLabel
												htmlFor="component-outlined"
												ref={ref => {
													this.labelRef = ReactDOM.findDOMNode(ref)
												}}
											>
												{'Dirección MAC'}
											</InputLabel>
											<OutlinedInput
												id="component-outlined"
												inputComponent={TextMaskCustom}
												labelWidth={
													this.labelRef ? this.labelRef.offsetWidth : 0
												}
												value={equipment.mac}
												onChange={event => {
													this.updateEquipmentState('mac', event.target.value)
												}}
											/>
										</FormControl>
									</Grid>

									<Grid item lg={6} md={12} sm={12}>
										<TextField
											select
											label="Estatus"
											variant="outlined"
											fullWidth
											margin="none"
											value={equipment.status}
											onChange={event => {
												this.updateEquipmentState('status', event.target.value)
											}}
										>
											{EQUIPMENT_STATUS.map(option => (
												<MenuItem key={option.value} value={option.value}>
													{option.label}
												</MenuItem>
											))}
										</TextField>
									</Grid>
								</Grid>
							</Paper>
						</Grid>
						<Grid item lg={4} md={4} sm={12}>
							<Toolbar disableGutters>
								<Typography variant="subtitle1" style={{ flex: 1 }}>
									{'Sensores'}
								</Typography>

							</Toolbar>
							<Paper style={{ padding: 16 }}>
								{devices && (
									<List className={classes.root}>
										{devices.map((sensor, index) => (
											<React.Fragment>
												<ListItem alignItems="flex-start">
													<ListItemText
														primary={sensor.name}
														secondary={
															<React.Fragment>
																<Typography
																	component="span"
																	style={{ display: 'inline' }}
																	color="textPrimary"
																>
																	{sensor.type}
																</Typography>
																{` - ${sensor._id}`}
															</React.Fragment>
														}
													/>
												</ListItem>
												{index !== devices.length - 1 && <Divider />}
											</React.Fragment>
										))}
									</List>
								)}

								{!devices.length && (
									<div style={{ textAlign: 'center' }}>
										<Typography variant="h5" style={{ marginBottom: 16 }}>
											{'No hay sensores todavía'}
										</Typography>

									</div>
								)}
							</Paper>
						</Grid>
					</Grid>
				</Segment>

				<Dialog
					open={this.state.modalScriptOpen}
					onClose={this.handleModalScriptClose}
					maxWidth="md"
				>
					<EquipmentsSTCodeDialog equipment={this.state.equipment} onClose={this.handleModalScriptClose} />
				</Dialog>

				<Snackbar
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right'
					}}
					open={this.state.snackbar.open}
					autoHideDuration={10000}
					onClose={this.closeSnackbar}
				>
					<MySnackbarContent
						message={this.state.snackbar.message}
						variant={this.state.snackbar.variant}
						onClose={this.closeSnackbar}
					/>
				</Snackbar>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	equipments: state.services.equipments
})

const mapDispatchToProps = dispatch => ({
	equipmentsFind: (query = {}) => dispatch(services.equipments.find(query)),
	store: data => dispatch(services.equipments.store(data)),
	equipmentGet: (id, params) => dispatch(services.equipments.get(id, params)),
	equipmentsPatch: (id, client) =>
		dispatch(services.equipments.patch(id, client))
})

export default withStyles(styles)(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(EquipmentsEdit)
)
